// extracted by mini-css-extract-plugin
export default {"wrapper":"GiftCards_wrapper__Mk8nL"};